import Vue from 'vue'

export const customerTypes = async function() {
  return [{header:'BC'},
                              {text:'LRS: Liquor Retail Store',value:'LRS',spirit:false,wine:false,prefInBond:false,prefCases:true},
                              {text:'MOS: Manufacturer On Site',value:'MOS',spirit:false,wine:false,prefInBond:false},
                              {text:'LIC: Licensee',value:'LIC',spirit:false,wine:false,prefInBond:false,prefCases:true},
                              {text:'RAS: Rural Agency Store',value:'RAS',spirit:false,wine:false,prefInBond:false,prefCases:true},
                              {text:'WIN: Wine Independent Store',value:'WIN',spirit:false,wine:false,prefInBond:false,prefCases:true},
                              {text:'LDB: BCLDB',value:'LDB',spirit:false,wine:false,prefInBond:true,prefCases:true},
                              {text:'Contract',value:'Contract',spirit:false,wine:false,prefInBond:true,prefCases:true}];
}
